
export const PROVISION_COLUMNS = [
  { id: 'knockOffStatus', label: 'Status', width: 150 },
  { id: 'vendorPAN', label: 'Vendor pan', width: 160 },
  { id: 'vendorName', label: 'Vendor name', width: 150 },
  { id: 'accountingDocumentNo', label: 'Accounting document no.', width: 220, align: 'center' },
  { id: 'postingDate', label: 'Posting date', width: 152 },
  { id: 'referenceNumber', label: 'Knock off reference no.', width: 220, align: 'center' },
  { id: 'tdsSection', label: 'TDS section', width: 152, align: 'center' },
  { id: 'grossExpenseAmount', label: 'Gross expense amount', width: 220, align: 'center' },
  { id: 'tdsBaseAmount', label: 'TDS base amount', width: 200, align: 'center' },
  { id: 'tdsAmount', label: 'TDS amount', width: 176, align: 'center' },
  { id: 'knockedOffTdsAmount', label: 'Knocked off tds amount', width: 220, align: 'center' },
  { id: 'tdsAmountBalance', label: 'Balance', width: 176, align: 'center' },
]

export const PROVISION_SEARCH_FIELDS = [
  ...PROVISION_COLUMNS
    .filter(col => col.id !== 'knockOffStatus' && col.id !== 'referenceNumber')
    .map(col => ({
      ...col,
      type: 'text',
      placeholder: `Enter ${col.label}`,
    }))
];
